import { render, staticRenderFns } from "./TitulosProblematicos.vue?vue&type=template&id=d1951de0"
import script from "./TitulosProblematicos.vue?vue&type=script&lang=js"
export * from "./TitulosProblematicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1951de0')) {
      api.createRecord('d1951de0', component.options)
    } else {
      api.reload('d1951de0', component.options)
    }
    module.hot.accept("./TitulosProblematicos.vue?vue&type=template&id=d1951de0", function () {
      api.rerender('d1951de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TitulosProblematicos.vue"
export default component.exports